module.exports = __webpack_public_path__ + "img/paneer.0c87b8b3.png";